import { Skeleton } from "primereact/skeleton";
import PropTypes from "prop-types";
import React from "react";

const MessageSkeleton = ({ nameWidth, dateWidth, messageWidth }) => {
  return (
    <div className="message-container">
      <Skeleton
        width="2rem"
        height="2rem"
        className="mb-2"
        shape="circle"
      ></Skeleton>
      <div className="skeleton-content">
        <div className="skeleton-meta-info">
          <Skeleton width={nameWidth} className="mb-2"></Skeleton>
          <Skeleton width={dateWidth} className="mb-2"></Skeleton>
        </div>
        <div className="skeleton-message">
          <Skeleton width={messageWidth} className="mb-2"></Skeleton>
        </div>
      </div>
    </div>
  );
};
MessageSkeleton.proptypes = {
  nameWidth: PropTypes.string,
  dateWidth: PropTypes.string,
  MessageWidth: PropTypes.string,
};

export default MessageSkeleton;
